<template>
  <div class="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
    <h2 class="mb-6 text-xl font-semibold text-slate-900">
      Common Interview Questions
    </h2>
    <div class="space-y-3">
      <div v-for="(question, index) in interviewQuestions" :key="index"
        class="flex items-start gap-3 rounded-lg border border-slate-200 bg-slate-50 p-4">
        <div class="flex-shrink-0">
          <div class="flex h-6 w-6 items-center justify-center rounded-full text-white text-sm font-bold"
            :style="{ backgroundColor: brandColor }">
            Q
          </div>
        </div>
        <p class="flex-1 text-slate-800">
          {{ question }}
        </p>
      </div>
    </div>
    <div class="mt-4 rounded-lg p-4 text-sm" :style="tipBoxStyles">
      <p>
        <strong>Tip:</strong> Prepare specific examples from your experience that demonstrate
        your skills and fit for the role at {{ companyName }}.
      </p>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  interviewQuestions: string[]
  brandColor: string
  companyName: string
}
const props = defineProps<Props>()
const getLightBackground = (color: string) => {
  const hex = color.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, 0.1)`
}
const tipBoxStyles = computed(() => ({
  backgroundColor: getLightBackground(props.brandColor),
  color: props.brandColor
}))
</script>